<template>
  <div id="app" v-title="title">
    <router-view />
  </div>
</template>

<script>

import config from './config'

export default {
  name: 'App',
  data() {
    return {
      title: config.title
    }
  }
}

</script>
